import {
  LOAD_CART,
  ADD_CART,
  REMOVE_CART,
  DEC_CART,
  INC_CART,
  UPDATE_CART_QUANTITY,
  EMPTY_CART
} from "../actions/cart";

const initialState = {
  items: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case EMPTY_CART:
      localStorage.removeItem("cart");
      return {
        ...state,
        items: []
      };
    case LOAD_CART:
      return {
        ...state,
        items: action.payload
      };
    case ADD_CART:
      const { items } = state;
      let item =
        items[items.findIndex(({ id }) => id === action.payload.product.id)];
      if (item) {
        item.quantity =
          parseInt(item.quantity) + parseInt(action.payload.quantity);
      } else {
        items.push(action.payload.product);
      }
      localStorage.setItem("cart", JSON.stringify(items));
      return {
        ...state,
        items
      };

    case REMOVE_CART:
      const removeItems = state.items.filter(
        item => item.id !== action.payload
      );
      localStorage.setItem("cart", JSON.stringify(removeItems));
      return {
        ...state,
        items: removeItems
      };

    case INC_CART:
      const incItems = state.items.map(item => {
        if (item.id === action.payload) item.quantity++;
        return item;
      });

      localStorage.setItem("cart", JSON.stringify(incItems));
      return {
        ...state,
        items: incItems
      };

    case DEC_CART:
      const decItems = state.items.map(item => {
        if (item.id === action.payload) item.quantity--;
        return item;
      });
      localStorage.setItem("cart", JSON.stringify(decItems));
      return {
        ...state,
        items: decItems
      };

    case UPDATE_CART_QUANTITY:
      const updateItems = state.items.map(item => {
        if (item.id === action.payload.id)
          item.quantity = action.payload.quantity;
        return item;
      });
      localStorage.setItem("cart", JSON.stringify(updateItems));
      return {
        ...state,
        items: updateItems
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/cartReducer.js